module.exports = __webpack_public_path__ + "4f1ae3cd6e1866fe70c223a44789dd3c.svg";